export type NameType = 'opening';

export const name: NameType = 'opening';
